/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const trackAlbumBindModelSchema = z.object({
    "albumId": z.string().uuid().describe("Идентификатор альбома"),
"name": z.string().describe("Название альбома"),
"releaseDate": z.string().date().describe("Дата выпуска").nullable().nullish()
    })